import { createApi } from '@reduxjs/toolkit/query/react';
import { axiosBaseQuery } from '../api/axiosBaseQuery';

export type AdminBotStats = {
  comercio_key: string;
  bot_id: number;
  total_tokens: number;
  total_cost_usd: number;
  conversations_handled: number;
};

export type AdminChatConversation = {
  id: number;
  patient_id: number;
  patient_name: string;
  title: string | null;
  is_saved: boolean;
  created_at: string;
  updated_at: string;
};

export type AdminChatMessage = {
  id: number;
  conversation_id: number;
  bot_id: number | null;
  role: string;
  content: string;
  response_time_ms: number | null;
  created_at: string;
};

export const adminApi = createApi({
  reducerPath: 'adminApi',
  baseQuery: axiosBaseQuery(),
  tagTypes: ['AdminBots'],
  endpoints: (builder) => ({
    getAdminBotStats: builder.query<AdminBotStats[], void>({
      query: () => ({
        url: '/v1/admin/bots-stats',
        method: 'GET',
      }),
      providesTags: ['AdminBots'],
    }),
    getAdminCommerceChatConversations: builder.query<AdminChatConversation[], string>({
      query: (comercioKey) => ({
        url: `/v1/admin/${comercioKey}/chat-conversations`,
        method: 'GET',
      }),
    }),
    getAdminCommerceChatMessages: builder.query<AdminChatMessage[], { comercioKey: string; conversationId: number }>({
      query: ({ comercioKey, conversationId }) => ({
        url: `/v1/admin/${comercioKey}/chat-conversations/${conversationId}/messages`,
        method: 'GET',
      }),
    }),
  }),
});

export const {
  useGetAdminBotStatsQuery,
  useGetAdminCommerceChatConversationsQuery,
  useGetAdminCommerceChatMessagesQuery,
} = adminApi;
